// extracted by css-extract-rspack-plugin
export default {"label":"D3xs8Q","icon":"Dj55wH"};